"use client";
import "../../../chunk-MMUBH76A.js";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
const excludedCountries = [
  "AC",
  "CG",
  "CI",
  "CV",
  "GF",
  "GP",
  "MF",
  "NC",
  "PM",
  "RE",
  "SD",
  "SH",
  "SJ",
  "TA",
  "VA",
  "WF",
  "XK",
  "YT"
];
const generateCountryCodes = () => {
  const countries = getCountries();
  const countryList = countries.filter((country) => !excludedCountries.includes(country)).map((country) => {
    const countryCode = getCountryCallingCode(country);
    const countryName = new Intl.DisplayNames(["en"], { type: "region" }).of(country);
    return {
      label: countryName,
      value: `+${countryCode}`,
      selectedLabel: country,
      icon: country
    };
  }).sort((a, b) => a.label.localeCompare(b.label));
  return countryList;
};
const countryCodes = generateCountryCodes();
var countryCodes_default = countryCodes;
export {
  countryCodes_default as default
};
